<div class="container-fluid service-bg">
    <div class="row">
        <div class="col-md-12 from-top text-center">
            <!-- Titles -->
            <h1 class="text-style">{{'gen_tv_login' | translate}} </h1>
            <p>{{'info_tv_login_msg' | translate}}</p>

            <!-- TV Login Form -->
            <div class="form-group login-form" [formGroup]="loginTvGroup">

                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_code' | translate}}</mat-label>
                    <textarea class="in-text-areas" matInput placeholder="{{'gen_code' | translate}}"
                        formControlName="tvCode"></textarea>
                </mat-form-field>

                <!-- Button -->
                <button class="button w-100" (click)="tvCodelogin()" [disabled]="loginTvGroup.status == 'INVALID'">
                    {{'gen_ok' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>